import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import axios from './plugins/axios'
// Third Party Dependencies
import vSelect from 'vue-select'
import { BootstrapVue } from 'bootstrap-vue'

// MAIN STYLE
import './assets/scss/main.scss'
import '@fortawesome/fontawesome-free/css/all.min.css'
import 'perfect-scrollbar/css/perfect-scrollbar.css'

import constants from './plugins/constants'
import helpers from './plugins/helpers'

Vue.use(BootstrapVue)
Vue.component('v-select', vSelect)

Vue.config.productionTip = false

Vue.prototype.$axios = axios
Vue.prototype.$constant = constants
Vue.prototype.$helper = helpers

axios.get('/menu').then(res => {
  const menus = res.data

  for (let i = 0; i < menus.length; i++) {
    const url = menus[i].Url
    const cleanUrl = url.endsWith('/')
      ? url + 'index'
      : url.replace(/\/:id/g, '')

    const newRoute = {
      path: url,
      name: menus[i].Name,
      component: () => import(`./views${cleanUrl}.vue`)
    }

    router.addRoutes([newRoute])
  }

  new Vue({
    store,
    router,
    render: h => h(App)
  }).$mount('#app')
})
